module.exports = __webpack_public_path__ + "static/media/06.7ebc53c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/06.jpg
// module id = 267
// module chunks = 0